<template>
  <div class="container">
    <form autocomplete="off" @submit.prevent="handleSubmit">
      <div class="row margin">
        <div class="form-group col-md-6">
          <h3>Motivo de contacto *</h3>
          <div class="relative"
            :class="{ 'has-error': errors.has('contact_subject'), 'has-success' : fields.contact_subject && fields.contact_subject.valid }"
          >
            <select
              name="contact_subject"
              id="contact_subject"
              class="form-control efecto"
              placeholder="Seleccione su motivo de contacto."
              v-validate="{ required: true, is_not: ''  }"
              v-model="user.motivo_id"
              data-vv-as="Motivo de contacto"
            >
              <option
                selected
                disabled
                value
              >Decinos por qué asunto querés que nos contactemos con vos</option>
              <option
                v-for="motivo in motivos"
                :key="motivo.id"
                :value="motivo.id"
              >{{ motivo.motivo }}</option>
            </select>
            <span class="focus-border"></span>
            <div
              v-if="errors.has('contact_subject')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('contact_subject') }}</div>
          </div>
        </div>
        <div class="form-group col-md-6">
          <h3>Forma de contacto *</h3>
          <div class="relative"
            :class="{ 'has-error': errors.has('contact_preference'), 'has-success' : fields.contact_preference && fields.contact_preference.valid }"
          >
            <select
              name="contact_preference"
              id="contact_preference"
              class="form-control efecto"
              placeholder="Seleccione su forma de contacto preferida."
              v-validate="{ required: true, is_not: ''  }"
              v-model="user.forma_id"
              data-vv-as="Forma de Contacto"
            >
              <option
                selected
                disabled
                value
              >Elegí la forma en que querés que nos comuniquemos con vos</option>
              <option v-for="forma in formas" :key="forma.id" :value="forma.id">{{ forma.forma }}</option>
            </select>
            <span class="focus-border"></span>
            <div
              v-if="errors.has('contact_preference')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('contact_preference') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h3>Datos personales</h3>
        </div>
        <div
          class="form-group col-md-6"
          :class="{'has-error' : errors.has('name'), 'has-success' : fields.name && fields.name.valid }"
        >
          <float-label>
            <input
              type="text"
              name="name"
              id="name"
              class="form-control efecto"
              placeholder="Nombre"
              v-model="user.nombre"
              v-validate="'required|alpha_spaces|max:255'"
              data-vv-as="Nombre"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('name')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('name') }}</div>
        </div>
        <div
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('lastname'), 'has-success' : fields.lastname && fields.lastname.valid }"
        >
          <float-label>
            <input
              type="text"
              name="lastname"
              id="lastname"
              class="form-control efecto"
              placeholder="Apellido"
              v-model="user.apellido"
              v-validate="'required|alpha_spaces|max:255'"
              data-vv-as="Apellido"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('lastname')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('lastname') }}</div>
        </div>
      </div>
      <div class="row">
        <div
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('lastname'), 'has-success' : fields.lastname && fields.lastname.valid }"
        >
          <float-label>
            <input
              type="text"
              name="dni"
              id="dni"
              class="form-control efecto"
              placeholder="DNI"
              v-model="user.dni"
              v-validate="'required|numeric|max:8'"
              data-vv-as="DNI"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('dni')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('dni') }}</div>
        </div>
        <div
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('phone'), 'has-success' : fields.phone && fields.phone.valid  }"
        >
          <float-label>
            <input
              type="tel"
              name="phone"
              id="phone"
              class="form-control efecto"
              placeholder="Teléfono"
              v-model="user.telefono"
              v-validate="'required|numeric|max:30'"
              data-vv-as="Teléfono"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('phone')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('phone') }}</div>
        </div>
      </div>
      <div class="row margin">
        <div
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('email'), 'has-success' : fields.email && fields.email.valid  }"
        >
          <float-label>
            <input
              type="email"
              name="email"
              id="email"
              class="form-control efecto"
              placeholder="Email"
              v-model="user.email"
              v-validate="'required|email'"
              ref="email"
              data-vv-as="Email"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('email')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('email') }}</div>
        </div>
        <div
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('email_confirm'), 'has-success' : fields.email_confirm && fields.email_confirm.valid  }"
        >
          <float-label>
            <input
              type="email"
              name="email_confirm"
              id="email_confirm"
              class="form-control efecto"
              placeholder="Verificar email"
              v-validate="'email|confirmed:email'"
              ref="confirmed"
              data-vv-as="Verificar email"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('email_confirm')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('email_confirm') }}</div>
        </div>
      </div>
      <div class="row">
        <span class="separador"></span>
        <div class="col-xs-12">
          <h3>Vehículo</h3>
        </div>
        <div class="form-group col-md-6">
          <float-label label="Modelo">
            <select
              name="model"
              id="model"
              class="form-control efecto"
              v-model="user.modelo_id"
              data-vv-as="Modelo"
            >
              <option selected value>Modelo</option>
              <option
                v-for="modelo in modelos"
                :key="modelo.id"
                :value="modelo.id"
              >{{ modelo.modelo }}</option>
            </select>
            <span class="focus-border"></span>
          </float-label>
        </div>
        <div class="form-group col-md-6">
          <float-label label="Patente">
            <input
              type="text"
              name="plate"
              id="plate"
              class="form-control efecto"
              placeholder="Patente"
              v-validate="'min:6|max:7'"
              v-model="user.patente"
              data-vv-as="Patente"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('plate')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('plate') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <float-label>
            <input
              type="text"
              name="chasis"
              id="chasis"
              class="form-control efecto"
              placeholder="Chasis"
              v-model="user.chasis"
              data-vv-as="Chasis"
            >
            <span class="focus-border"></span>
          </float-label>
        </div>
        <div class="form-group col-md-6">
          <float-label label="Concesionaria">
            <select
              name="concesionaria"
              id="concesionaria"
              class="form-control efecto"
              placeholder="Concesionaria"
              v-model="user.concesionaria_id"
              data-vv-as="Concesionaria"
            >
              <option selected value="">Concesionaria</option>
              <option
                v-for="concesionaria in concesionarias"
                :key="concesionaria.id"
                :value="concesionaria.id"
              >{{ concesionaria.nombre }} ({{concesionaria.localidad}})</option>
            </select>
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('plate')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('plate') }}</div>
        </div>
      </div>
      <div class="row">
        <span class="separador2"></span>
        <div class="col-xs-12">
          <h3>Consulta *</h3>
        </div>
        <div
          class="form-group col-xs-12 efecto"
          :class="{ 'has-error': errors.has('message'), 'has-success' : fields.message && fields.message.valid }"
        >
          <div class="relative">
            <textarea
              name="message"
              id="message"
              cols="30"
              rows="10"
              class="form-control efecto"
              v-validate="'required'"
              v-model="user.mensaje"
              data-vv-as="Mensaje"
              Placeholder="Por favor, ingresá tu consulta"
            ></textarea>
            <span class="focus-border"></span>
            <div
              v-if="errors.has('message')"
              class="animated headShake bg-danger text-danger" style="position: absolute;"
            >{{ errors.first('message') }}</div>
          </div>
        </div>

        <div class="col-xs-12">
          <div class="checkbox">
            <label>
              <input
                type="checkbox"
                id="tyc"
                name="tyc"
                v-validate="'required'"
                data-vv-as="Políticas de uso"
              > <span class="checkbox-custom"></span>He leído y acepto la <a href="https://www.volkswagen.com.ar/es/informaciones-legales/politica-de-privacidad.html" target="_blank" rel="noopener" @click.stop>Política de Privacidad</a>
            </label>
            <div
              v-if="errors.has('tyc')"
              class="animated headShake bg-danger text-danger"
            >{{ errors.first('tyc') }}</div>
          </div>
        </div>

        <div class="col-xs-12">
          <button type="submit" class="btn btn-default btn-primary" :disabled="cargando || errors.any()"><span v-text="cargando ? 'Enviando' : 'Enviar'"></span></button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import FloatLabel from "vue-float-label/components/FloatLabel";

export default {
  name: "Form",
  components: {
    FloatLabel
  },
  props: ["motivos", "formas", "modelos", "concesionarias"],
  data() {
    return {
      cargando: false,
      user: {
        motivo_id: "",
        forma_id: "",
        nombre: "",
        apellido: "",
        telefono: "",
        email: "",
        modelo_id: "",
        patente: "",
        mensaje: "",
        chasis: "",
        dni: "",
        concesionaria_id: "",
        concesionaria: ""
      },
      submitted: false,
      API_URL:
        window.location.hostname === "localhost"
          ? "https://d6-precios.vwcontenidos.com.ar/api/contacto"
          : "https://d6-precios.vwcontenidos.com.ar/api/contacto"
    };
  },
  watch: {
    "user.modelo_id": function(val) {
      if (val === "") {
        this.user.patente = "";
      }
    },
    "user.concesionaria_id": function(val) {
      if (val === "") {
        this.user.concesionaria = "";
      } else {
        this.user.concesionaria = this.concesionarias.find(function(item){
          return item.id === val
        })
      }
    },
  },
  computed: {
    motivo: function() {
      let self = this;
      return this.motivos.find(motivo => motivo.id === self.user.motivo_id);
    },
    modelo: function() {
      let self = this;
      return this.modelos.find(modelo => modelo.id === self.user.modelo_id);
    }
  },
  methods: {
    getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
          vars[key] = value;
      });
      return vars;
    },
    handleSubmit() {
      this.cargando = true;
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          let form_data = new FormData();
          let item = this.user;

          for (let key in item) {
            form_data.append(key, item[key]);
          }
          // const urlParams = new URLSearchParams(window.location.href);
          // const origin = urlParams.get('origin') ? urlParams.get('origin') : 0;
          const origin = this.getUrlVars()["origin"];
          form_data.append('origin', origin);

          (window.smartSignals2 = window.smartSignals2 || []).push({
            event: "FormSubmissionCustomerService",
            payload: {
              leadInformation: {
                version: "1.0",
                leadType: "6",
                formName: this.motivo.smart,
                productName: this.modelo ? this.modelo.modelo : null
              }
            }
          });
          axios
            .post(this.API_URL, form_data, {
              headers: {
                "Content-type": "application/x-www-form-urlencoded"
              }
            })
            .then(res => {
              this.cargando = false;
              if (res.status === 200) {
                swal({
                  type: "success",
                  text: res.data,
                  confirmButtonText: "Volver",
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  onAfterClose: function() {
                    window.location = "https://www.volkswagen.com.ar/es.html";
                  }
                });
              } else {
                swal({
                  type: "error",
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  text:
                    "Ocurrió un error, por favor intente nuevamente más tarde."
                });
              }
            })
            .catch(() => {
              swal({
                type: "error",
                allowEscapeKey: false,
                allowOutsideClick: false,
                text:
                  "Ocurrió un error, por favor intente nuevamente más tarde."
              });
            });
        } else {
          this.cargando = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_vw-tokens.scss";

* {
  transition: all 0.3s ease;
}

.text-danger {
  padding: 0.5em;
  border-radius: 4px;
}

textarea {
  min-width: 100%;
  max-width: 100%;
}

form {
  padding-top: 1.1em;
  & > .row.margin {
    margin-bottom: 6.7em;
  }
  & > .row:not(.margin) {
    margin-bottom: 0.8em;
  }
  h3 {
    font-size: 2.3em;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    font-weight: 400;
    letter-spacing: -0.04em;
    margin-bottom: 1.55em;
  }
  input,
  select,
  textarea {
    color: $vw-content;
    background: transparent;
    border: none;
    border-bottom: 1px solid $vw-input-border;
    box-shadow: none;
    border-radius: 0;
    font-size: 1.2em;
    padding: 0;
    letter-spacing: -0.035em;
    outline: none !important;
    &:hover,
    &:focus {
      box-shadow: none;
    }
    &:focus,
    &:active {
      outline: none !important;
      border-color: $vw-border-selected;
    }
    &.efecto ~ .focus-border {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 1px;
      background-color: $vw-border-selected;
      transition: 0.4s;
    }
    &.efecto:focus ~ .focus-border {
      width: 100%;
      transition: 0.4s;
      left: 0;
    }
  }
  select {
    -webkit-appearance: none;
    appearance: none;
  }
  textarea {
    resize: none;
    margin-top: 0.3em;
    height: 1.6em;
  }
  .separador,
  .separador2 {
    display: block;
    height: 1.4em;
  }
  .separador2 {
    height: 7em;
  }
  .checkbox {
    color: $vw-blue;
    font-size: 1.4em;
    margin-top: 2.1em;
    @media (max-width: 669px) {
      font-size: 1.8em;
    }
    a {
      color: $vw-blue;
      text-decoration: underline;
      &:hover,
      &:focus {
        color: $vw-border-selected;
      }
    }
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
    label {
      padding-left: 2em;
      vertical-align: text-bottom;
      line-height: 0.6em;
      letter-spacing: -0.007em;
      @media (max-width: 1441px) {
        line-height: 1.4em;
      }
      @media (max-width: 669px) {
        line-height: 0.3em;
      }
    }
    .checkbox-custom {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 24px;
      width: 24px;
      background-color: transparent;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -ms-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
      border: 2px solid $vw-input-border;
      border-radius: 0;
    }
    input:checked ~ .checkbox-custom {
      background-color: $vw-blue;
      -webkit-transform: rotate(0deg) scale(1);
      -ms-transform: rotate(0deg) scale(1);
      transform: rotate(0deg) scale(1);
      opacity: 1;
      border: 2px solid $vw-blue;
    }
    .checkbox-custom::after {
      position: absolute;
      content: "";
      left: 12px;
      top: 12px;
      height: 0px;
      width: 0px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(0deg) scale(0);
      -ms-transform: rotate(0deg) scale(0);
      transform: rotate(0deg) scale(0);
      opacity: 1;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -ms-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
    }
    input:checked ~ .checkbox-custom::after {
      -webkit-transform: rotate(45deg) scale(1);
      -ms-transform: rotate(45deg) scale(1);
      transform: rotate(45deg) scale(1);
      opacity: 1;
      left: 8px;
      top: 3px;
      width: 6px;
      height: 12px;
      border: solid white;
      border-width: 0 2px 2px 0;
      background-color: transparent;
      border-radius: 0;
    }
  }
  .btn.btn-primary {
    border-radius: $vw-radius-pill;
    margin: 7em 0;
    font-size: 1.2em;
    padding: 0.6em 2.8em;
    letter-spacing: -0.04em;
    color: $vw-on-dark;
    background: $vw-blue;
    border: 1px solid $vw-blue;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;
    &:hover,
    &:active {
      background: $vw-btn-selected;
      border-color: $vw-btn-selected;
      color: $vw-content;
      box-shadow: $vw-shadow-hover;
    }
    &:focus-visible {
      outline: 2px solid $vw-focus-ring;
      outline-offset: 2px;
    }
    &:disabled {
      opacity: 0.2;
    }
    @media (max-width: 669px) {
      display: block;
      width: 100%;
      font-size: 1.4em;
      padding: 0.6em;
      margin: 2em 0;
    }
  }
  .relative {
    position: relative;
  }
  .has-success .form-control,
  .has-success .form-control:focus,
  .has-error .form-control,
  .has-error .form-control:focus {
    box-shadow: none;
    border-color: $vw-input-border;
  }

  .text-danger {
    background: transparent;
    color: #e4002c;
    padding: 2px;
  }
}
</style>
